import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getOrderDoneByList = createAsyncThunk(
  'general/orderDoneBy',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/general/list/orderDoneBy');
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export default getOrderDoneByList;
